// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mLigc0Of{align-items:center;display:flex;gap:.75rem}.A-3r3Y9m,.NEWq4gs5{background-color:var(--color-gray-2);border-radius:.75rem;flex-shrink:0;height:3.38rem;-o-object-fit:cover;object-fit:cover;width:3.38rem}.pt4h\\+IOe{min-width:0}.kZ17OmcW{color:var(--color-fg);font-size:1rem;font-weight:600;line-height:1.5rem}.NCaHsJdQ{color:var(--color-gray-4);display:-webkit-box;font-size:.75rem;line-height:1rem;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"speaker": "mLigc0Of",
	"photo": "A-3r3Y9m",
	"photoPlaceholder": "NEWq4gs5",
	"info": "pt4h+IOe",
	"name": "kZ17OmcW",
	"role": "NCaHsJdQ"
};
module.exports = ___CSS_LOADER_EXPORT___;
